function setupRActionMail() {
  ractionSetup($('#rmail'));
  $('#rmail form').submit(function () {
    console.log("#rmail submit handler!");
    $('#rmail button').prop('disabled', true);
    $('#rmail .fa-spinner').show();
    $.post($(this).attr('action'), $(this).serialize()).done(function (data) {
      nextAction();
    }).fail(function (jqXHR) {
      $('#rmail').replaceWith(jqXHR.responseText);
    });
    return false;
  });

  // Make validation apply to the email fields as well as the member
  // fields.  Also requires a class of 'js-member-subject' and
  // 'js-member-body' to be applied to the relevent input elements parent 
  MemberForm.data.push('subject');
  MemberForm.data.push('body');
}

function setupNamesFromCheckboxesMail(label) {
  window.namesFromCheckboxes = function(names, checkboxes) {
    if (checkboxes.length > 0) {
      $(names).parent().show()
      $(names).text($.map(checkboxes, function (e) {
        return $(e).parent().text().split(",")[0].replace(/ \(.+\)/, '')
      }).join(", ").replace(/,\s([^,]+)$/, label + '$1'))
    } else {
      $(names).parent().hide();
    }
  }
}

function bindMailActionClickListener() {
  $('#primaries-checkboxes input,#secondaries-checkboxes').on('change', function () {
    namesFromCheckboxes($('#primaries-names'), $('#primaries-checkboxes input:checked'));
    namesFromCheckboxes($('#secondaries-names'), $('#secondaries-checkboxes input:checked'));
    if ($('#primaries-checkboxes input:checked').length == 0 &&
        $('#secondaries-checkboxes input:checked').length == 0) {
      $('.js-decision-checkboxes').addClass('invalid-inputs');
      $('.js-decision-checkboxes .js-invalid-input-message').show();
      $('#rmail .js-submit').attr('disabled', true);
    }
    else {
      $('.js-decision-checkboxes').removeClass('invalid-inputs');
      $('.js-decision-checkboxes .js-invalid-input-message').hide();
      $('#rmail .js-submit').attr('disabled', false);
    }
  });

  namesFromCheckboxes($('#primaries-names,#title-names'), $('#primaries-checkboxes input:checked'));
  namesFromCheckboxes($('#secondaries-names'), $('#secondaries-checkboxes input:checked'));
}


$(document).ready(function(){
  $('#rmail .js-submit').on('click', function () {
    inputs = new MailInputs($('#rmail form'));
    inputs.decorate()
  });
});


/*** EXPORTS FROM exports-loader ***/
exports["setupRActionMail"] = (setupRActionMail);
exports["setupNamesFromCheckboxesMail"] = (setupNamesFromCheckboxesMail);
exports["bindMailActionClickListener"] = (bindMailActionClickListener);